import moment from "moment-timezone"

import { Button, Typography} from "@mui/material"

const SupportThread = ({thread, closeThread }) => {

  return (
    <div className='flex flex-row gap-5 w-full justify-between mb-10'>
      <div className="flex flex-col gap-2 p-5">
        <Typography variant="h4">{thread?.subject}</Typography>
        <Typography variant="h6">{thread?.username}</Typography>
        <Typography variant="caption" color="textSecondary">{thread && moment(thread.created_date).format("DD/MM/YYYY HH:mm")}</Typography>
        
      </div>
      <div className="mr-5 mt-5">
        <Button onClick={() => closeThread()} variant="contained" disabled={!thread || thread.status === "closed"}>Close thread</Button>
      </div>
    </div>
  )
}

export default SupportThread
